import React, { Component, useState, useEffect } from "react";
import AuthHeader from "./AuthHeader";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import { Button, Input, Modal } from "antd";

function ResetPassword(props) {
  const { link } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [expiredModalOpen, setExpiredModalOpen] = useState(false);

  const CheckUrlParamIsValid = async () => {
    let response = await props.AxiosRequest("/api/user/check-reset-link", { param: link }, true);
    if (response.data.status === "error" || response.data.status === "warning") return setExpiredModalOpen(true);
  };
  const SubmitPassword = async () => {
    if (password.length < 8) return props.MakeNotification("info", "Your password must be at least 8 characters long.");
    if (password !== confirmPassword) return props.MakeNotification("error", "The passwords entered don't match.");
    let response = await props.AxiosRequest("/api/user/reset-password", {
      param: link,
      password: password,
    });
    if (response.data.status === "success") navigate("/auth/login");
  };
  useEffect(() => {
    CheckUrlParamIsValid();
  }, []);
  return (
    <div>
      <AuthHeader />

      <main className="main h-100 w-100">
        <div className="container h-100">
          <div className="row h-100" id="success-show">
            <div className="col-sm-10 col-md-8 col-lg-6 mx-auto d-table h-100">
              <div className="d-table-cell align-middle">
                <div className="text-center mt-4">
                  <h1 className="h2">Password Reset</h1>
                  <p className="lead">Fill out the fields below to reset your password.</p>
                </div>
                <div className="card" id="success-card">
                  <div className="card-body">
                    <div className="m-sm-4">
                      <div className="mb-3">
                        <label>Password</label>
                        <Input className="form-control form-control-lg" type="password" name="password" placeholder="Enter password" value={password} onChange={(e) => setPassword(e.target.value)} />
                      </div>
                      <div className="mb-3">
                        <label>Confirm Password</label>
                        <Input
                          className="form-control form-control-lg"
                          type="password"
                          name="password"
                          placeholder="Confirm password"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                      </div>
                      <div className="text-center mt-3">
                        <Button type="primary" id="button-next" onClick={SubmitPassword}>
                          Save New Password
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* FAILURE CARD */}
          <Modal open={expiredModalOpen}>
            <div className="container h-100" id="failure-show">
              <div className="row h-100">
                <div className=" col-lg-12 mx-auto d-table h-100">
                  <div className="d-table-cell align-middle"></div>
                  <div className="text-center mt-4">
                    <h1 className="h2">Expired Link</h1>
                    <p className="lead">Oops! It looks like this link is expired.</p>
                  </div>
                  <div className="card" id="success-card">
                    <div className="card-body text-center">
                      <div className="m-sm-4">
                        <div className="mb-3">
                          If you are trying to set up your password, please make sure you are using the correct link. <br></br>If you are trying to reset your password, please try again.
                          <br></br>
                          <br></br>
                          <small>
                            If you continue to have problems, please reach out to us <Link to="mailto:support@firmtamer.com">here</Link>
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </main>
    </div>
  );
}

export default ResetPassword;
